import { motion, AnimatePresence } from "motion/react";
import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { textFieldStyle } from "../Styles";
import { useState } from "react";
import Inversion from "./Inversion";
import ContratosPagos from "./ContratosPagos";
import Morosos from "./Morosos";

const Reportes = () => {

    const [tipoReporte, setTipoReporte] = useState(0)
    const [viewInversionIndividual, setViewInversionIndividual] = useState(false)
    const [viewContratosPagos, setViewContratosPagos] = useState(false)
    const [viewMorosos, setViewMorosos] = useState(false)


    const handleTipoReporte = (e) => {

        const { value, name } = e.target

        setTipoReporte(value)

        switch (value) {
            case 1:
                //mostrar componente de inversion individual (agregar manualmente cuando se ha invertido IVAN - DONATO)
                setViewContratosPagos(false)
                setViewMorosos(false)
                setViewInversionIndividual(true)
                break;
            case 2:
                //mostrar componente de contratos-pagos(cuanto se presto, cuanto se a devuelto, en fechas determinadas)
                setViewInversionIndividual(false)
                setViewMorosos(false)
                setViewContratosPagos(true)
                break;
            case 3:
                //mostrar componente morosos (mostrar los que no han pagado y que pagos, que esten retrasados los pagos)
                setViewInversionIndividual(false)
                setViewContratosPagos(false)
                setViewMorosos(true)
                break;

            default:
                return
        }


    }


    return (
        <>
            <div className="container">
                <motion.div layout className="row">
                    <div className="col-md-12">
                        <AnimatePresence mode="popLayout">
                            <motion.div
                                layout
                                key="form-card"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0, y: -30 }}   // ⬅️ efecto de salida de la tarjeta completa
                                transition={{ duration: 0.4, ease: "easeInOut" }}
                            >

                                <div
                                    className="card shadow-lg  p-5 border-0"
                                    style={{ borderRadius: '20px' }}
                                >
                                    <div className="row">
                                        <motion.h1 className="color-primary"
                                            initial={{ opacity: 0, y: -90 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                            Reportes
                                        </motion.h1>
                                        <hr className="mb-5" />

                                        <motion.div
                                            className="col-md-6 mb-3"
                                            initial={{ opacity: 0, x: -50 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 1 }}
                                        >
                                            <FormControl fullWidth sx={textFieldStyle}>
                                                <InputLabel id="demo-simple-select-label">Tipo de Reporte</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={tipoReporte}
                                                    label="Tipo Reporte"
                                                    onChange={handleTipoReporte}

                                                >
                                                    <MenuItem value={0} disabled>-SELECCIONAR TIPO DE REPORTE</MenuItem>
                                                    <MenuItem value={1}>INVERSION INDIVIDUAL</MenuItem>
                                                    <MenuItem value={2}>CONTRATOS-PAGOS</MenuItem>
                                                    <MenuItem value={3}>MOROSOS</MenuItem>


                                                </Select>
                                            </FormControl>
                                        </motion.div>

                                        {viewInversionIndividual &&
                                            <AnimatePresence mode="popLayout">
                                                <Inversion />
                                            </AnimatePresence>
                                        }

                                        {viewContratosPagos &&
                                            <AnimatePresence mode="popLayout">
                                                <ContratosPagos />
                                            </AnimatePresence>
                                        }

                                        {viewMorosos &&
                                            <AnimatePresence mode="popLayout">
                                                <Morosos />
                                            </AnimatePresence>
                                        }


                                    </div>

                                </div>



                            </motion.div>


                        </AnimatePresence>
                    </div>

                </motion.div>


            </div>
        </>
    )

}


export default Reportes